export { ConnectedProformaRequestCreate } from './ui';

import type { LoadableLoadingComponentProps } from '@helpcenter/lazy';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import { withFadeIn } from 'view/common/with-fade-in';

export interface CreateAsyncProformaRequestCreateOptions {
	LoadingSkeleton?: React.ComponentType<LoadableLoadingComponentProps>;
	onLoaded?: () => void;
}

export const createAsyncProformaRequestCreate = (
	options?: CreateAsyncProformaRequestCreateOptions,
) =>
	withAsync({
		LoadingSkeleton: options?.LoadingSkeleton,
		loader: lazyForPaint(
			() =>
				import(/* webpackChunkName: "proforma-request-create" */ './ui').then((module) => {
					options?.onLoaded?.();
					return withFadeIn()(module.ConnectedProformaRequestCreate);
				}),
			{
				ssr: false,
			},
		),
	});

export const AsyncProformaRequestCreate = createAsyncProformaRequestCreate();

export type { OwnProps } from './ui/types';
export type {
	RegisterProformaForm,
	ValidateProformaForm,
	SerializeProformaForm,
} from './common/types/registration';
